import { render } from "./TargetGroup.vue?vue&type=template&id=593e2ca8&scoped=true"
import script from "./TargetGroup.vue?vue&type=script&lang=js"
export * from "./TargetGroup.vue?vue&type=script&lang=js"

import "./TargetGroup.vue?vue&type=style&index=0&id=593e2ca8&scoped=true&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593e2ca8"]])

export default __exports__